import { Scale } from "lucide-react";

export const Brand = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="nav-brand-logo">
    <div className="relative">
      <div className="w-10 h-10 rounded-full border border-amber-500/40 flex items-center justify-center bg-[#FFFFFF]">
        <Scale className="w-5 h-5 text-amber-600" strokeWidth={1.5} />
      </div>
    </div>
    <div className="leading-tight">
      <div className="font-serif text-lg text-stone-900 tracking-tight">Ius<span className="text-amber-600/90">Fera</span></div>
      <div className="text-[10px] uppercase tracking-[0.3em] text-amber-600/70 font-medium">Studio Legale</div>
    </div>
  </div>
);
